import ModuleWrapper from 'shared-lib/containers/Module';

const AdvertiserExternalIntegrationAdd = () => import(/* webpackChunkName: "add-external-integration" */ '@/views/advertisers/externalIntegrations/ExternalIntegration01Add');
const ExternalIntegrations = () => import (/* webpackChunkName: "external-integrations" */ '@/views/externalIntegrations/ExternalIntegrations');

const meta = (data = {}) => ({
    auth: true,
    privilegeModule: 'external_integrations',
    ...data,
});

export default [{
    path: 'external-integrations',
    component: ModuleWrapper,
    meta: meta({
        permission: 'read',
        title: 'UpyieldExchange',
    }),
    children: [
        {
            path: '',
            name: 'UpyieldExchange',
            component: ExternalIntegrations,
            props: true,
            meta: meta(),
        },
        {
            path: 'add',
            name: 'ExternalIntegrationAdd',
            component: AdvertiserExternalIntegrationAdd,
            props: true,
            meta: meta({
                permission: 'write',
            }),
        },
    ],
}];


